import { PayloadAction } from "@reduxjs/toolkit";
import { makeRequest } from "app/utils/makeRequest";
import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  GET_POLICY_VIEW_FINANCING_MODEL,
  policyViewFetchError,
  policyViewFetchStart,
  policyViewFetchSuccess,
} from "app/redux/features/policy-view-financing-model";

function* policyViewFinancingModelRequest(
  actions: PayloadAction<{ proposalId: string; userId: string }>,
): Generator<any, void, any> {
  try {
    const {
      payload: { proposalId, userId },
    } = actions;
    yield put(policyViewFetchStart());
    const response = yield call(() =>
      makeRequest("policyViewFinancingModel").get(`${proposalId}/${userId}`, true, false),
    );
    yield put(policyViewFetchSuccess(response.data));
  } catch (err: any) {
    yield put(policyViewFetchError(err));
  }
}

function* watcher() {
  yield takeLatest(GET_POLICY_VIEW_FINANCING_MODEL, policyViewFinancingModelRequest);
}

export default function* policyViewFinancingModelSaga() {
  yield all([watcher()]);
}
